import React, { Fragment, useContext } from 'react';
import Button from "@scentregroup/ui/components/form/button";
import trackClickEvent from '../../helpers/analytics-utils/track-event';
import { categories, actions } from '../../helpers/analytics-utils/constants';
import { WhatsOnSeeMoreContext } from '../../context';
import WhatsOnListItem from './whats-on-list-item';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WhatsOnMoreList = _ref => {
  let {
    range,
    items
  } = _ref;
  const {
    state,
    dispatch
  } = useContext(WhatsOnSeeMoreContext);
  const showItems = state && state[range];
  const label = 'See more';
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [showItems && items.map(item => /*#__PURE__*/_jsx(WhatsOnListItem, {
      item: item,
      "data-id": "whats-on-list_whats-on-more-list_WhatsOnMoreList_WhatsOnListItem"
    }, item.slug)), !showItems && /*#__PURE__*/_jsx("li", {
      className: style.showMore,
      "data-id": "whats-on-list_whats-on-more-list_WhatsOnMoreList_li",
      children: /*#__PURE__*/_jsx(Button, {
        type: "primary",
        className: style.showMoreButton,
        onClick: () => {
          trackClickEvent("".concat(categories.WHATS_HAPPENING_SEE_MORE, " - ").concat(range), actions.CTA, label);
          return dispatch({
            type: 'expand_see_more',
            range
          });
        },
        "data-id": "whats-on-list_whats-on-more-list_WhatsOnMoreList_li_Button",
        children: label
      })
    })]
  });
};
export default WhatsOnMoreList;